// action - account reducer firebase
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const FIREBASE_STATE_CHANGED = "FIREBASE_STATE_CHANGED";

// action admin - Login in MERN
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const SET_ALERT = "SET_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALL_ALERT = "DELETE_ALL_ALERT";

//user get details
export const GET_ALL_User = "GET_ALL_User";
export const GET_USER_DETAILS = "GET_USER_DETAILS";

export const GET_LANGUAGES = "GET_LANGUAGES";
export const GET_LABELS = "GET_LABELS";
export const GET_LABELS_Name = "GET_LABELS_Name";

export const GET_ALL_CMS = "GET_ALL_CMS";
export const GET_CMS_DETAILS = "GET_CMS_DETAILS";

//department
export const DEPARTMENT_LIST = "DEPARTMENT_LIST";
export const DEPARTMENT_DETAILS = "DEPARTMENT_DETAILS";
//setting get
export const GET_SETTING = "GET_SETTING";

// Property
export const PROPERTY_LIST = "PROPERTY_LIST";
export const PROPERTY_DETAIL = "PROPERTY_DETAIL";
export const GET_APPLIED_USERS_FOR_PROPERTY = "GET_APPLIED_USERS_FOR_PROPERTY";

export const ALL_PROPERTY_DETAIL = "ALL_PROPERTY_DETAIL";
export const ALL_PROPERTY_LIST = "ALL_PROPERTY_LIST";

// Rental Aggrement
export const AGGREMENT_LIST = "AGGREMENT_LIST";
export const AGGREMENT_DETAIL = "AGGREMENT_DETAIL";

// Support Staff
export const SUPPORT_STAFF_LIST = "SUPPORT_STAFF_LIST";
export const SUPPORT_STAFF_DETAIL = "SUPPORT_STAFF_DETAIL";

// Support Staff Reply
export const SUPPORT_STAFF_REPLY = "SUPPORT_STAFF_REPLY";

// Get property request chat
export const PROPERTY_REQUEST_CHAT = "PROPERTY_REQUEST_CHAT";

// Notification
export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";
export const GET_UNREAD_NOTIFICATION = "GET_UNREAD_NOTIFICATION";

// Chats
export const GET_ALL_CHAT = "GET_ALL_CHAT";
export const GET_FIREBASE_MSG = "GET_FIREBASE_MSG";

// report property
export const GET_ALL_REPORTED_PROPERTIES = "GET_ALL_REPORTED_PROPERTIES";
export const GET_REPORTED_PROPERTY_DETAILS = "GET_REPORTED_PROPERTY_DETAILS";

// Apply property
export const GET_APPLY_PROPERTY = "GET_APPLY_PROPERTY";
export const GET_APPLICATION_DETAILS = "GET_APPLICATION_DETAILS";

export const GET_ALL_SUBSCRIPTION = "GET_ALL_SUBSCRIPTION";
export const GET_RUNNING_SUBSCRIPTION = "GET_RUNNING_SUBSCRIPTION";
export const GET_DASHBOARD_DETAILS = "GET_DASHBOARD_DETAILS";

export const GET_TENANT_LIST = "GET_TENANT_LIST";
export const GET_TENANT_DETAILS = "GET_TENANT_DETAILS";

export const GET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";
export const GET_ANALYTICS_CARD_DATA = "GET_ANALYTICS_CARD_DATA";

export const GET_ALL_ADS = "GET_ALL_ADS";
export const REGISTER_OTP = "REGISTER_OTP";

// subscription history
export const GET_ALL_SUBS_HISTORY = "GET_ALL_SUBS_HISTORY";

export const FORGOT_PASSWORD_SENT_OTP = "FORGOT_PASSWORD_SENT_OTP";
export const FORGOT_PASSWORD_CHECK_OTP = "FORGOT_PASSWORD_CHECK_OTP";
export const CHANGED_PASSWORD = "CHANGED_PASSWORD";

export const GET_ALL_DASBOARD_CHAT = "GET_ALL_DASBOARD_CHAT";
export const GET_ALL_AGENCY_RENT = "GET_ALL_AGENCY_RENT";

export const GET_CMS_CONTENT = "GET_CMS_CONTENT";
export const LOAD_CMS_CONTENT = "LOAD_CMS_CONTENT";
export const GET_ALL_CARDS = "GET_ALL_CARDS";
